module.exports = __webpack_public_path__ + "img/bm.0d42c0bb.png";